import React, { useEffect, useState } from 'react';
import { RootState } from 'src/store/reducers/state';
import { useCategoryActions } from 'src/store/category/actions';
import { useDispatch, useSelector } from 'react-redux';
import AddNewAudienceProfile from '../AddNewAudienceProfile';
import DeleteAudienceProfileModal from '../DeleteAudienceProfileModal';
import Pagination from 'src/components/common/pagination';
import { CategoryData } from 'src/models/categoryModel';
import { DebounceInput } from 'react-debounce-input';
interface IProps {
  setSelectedAudienceProfileId: (value: CategoryData) => void;
  setTabFlag: (value: number) => void;
}
const AudienceProfiles: React.FC<IProps> = ({ setSelectedAudienceProfileId, setTabFlag }) => {
  const dispatch = useDispatch();
  const categoryActions = useCategoryActions(dispatch);
  const [contentTypeAddFlag, setContentTypeAddFlag] = useState<string>('Add');
  const [searchValue, setSearchValue] = useState<string>('');
  const [audienceProfileId, setAudienceProfileId] = useState<string>('');
  const {
    isAudienceProfilesSaved,
    audienceProfile,
    audienceProfilePaginationMeta,
    isAudienceProfilesDeleted
  } = useSelector((state: RootState) => {
    return {
      isAudienceProfilesSaved: state.category.isAudienceProfilesSaved,
      audienceProfile: state.category.audienceProfile,
      audienceProfilePaginationMeta: state.category.audienceProfilePaginationMeta,
      isAudienceProfilesDeleted: state.category.isAudienceProfilesDeleted
    };
  });

  useEffect(() => {
    if (isAudienceProfilesSaved || isAudienceProfilesDeleted) {
      categoryActions.getAudienceProfilesRequest({ pageNumber: 1 });
    }
  }, [isAudienceProfilesSaved, isAudienceProfilesDeleted]);

  const handleEditClick = (audienceProfileId: string) => {
    categoryActions.getSingleAudienceProfilesRequest(audienceProfileId);
    setContentTypeAddFlag('Edit');
  };
  const handlePageChange = (pageNumber: number) => {
    const data = { querySearch: searchValue, pageNumber };
    categoryActions.getAudienceProfilesRequest(data);
  };
  const handleDeleteClick = (data: CategoryData) => {
    setAudienceProfileId(data.id);
    setSelectedAudienceProfileId({ id: data.id, name: data.name });
    setTabFlag(4);
  };
  const handleSearchContentType = (e: string) => {
    setSearchValue(e);
    categoryActions.getAudienceProfilesRequest({ querySearch: e, pageNumber: 1 });
  };
  return (
    <>
      <div className="tab-pane fade " id="tabs-audienceProfiles" role="tabpanel">
        <div className="py-5 px-7">
          <div className="px-5 py-4 border-b border-gray-100 md:flex justify-between items-center">
            <h2 className="font-semibold "></h2>
            <div className="md:flex items-center text-center">
              <div className="form-group md:flex items-center text-center">
                <label className="mr-1 font-semibold">Search:</label>
                <DebounceInput
                  placeholder="Search"
                  minLength={1}
                  className="input-style w-48 mr-3 mb-1"
                  debounceTimeout={500}
                  onChange={(event) => handleSearchContentType(event.target.value)}
                />
              </div>
              <button
                onClick={() => setContentTypeAddFlag('Add')}
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#AddNewAudienceProfile"
                className="btn-primary w-auto mt-0 mr-0 ml-auto borderonly-btn">
                Add
              </button>
            </div>
          </div>
          <div className="overflow-x-auto-sm">
            <table className="table-auto w-full border">
              <thead className="text-xs font-semibold uppercase bg-gray-100">
                <tr>
                  <th className="p-2">
                    <div className="font-semibold text-left">Profile Name</div>
                  </th>
                  <th className="p-2">
                    <div className="font-semibold text-left">Description</div>
                  </th>
                  <th className="p-2">
                    <div className="text-left invisible">Action</div>
                  </th>
                </tr>
              </thead>
              <tbody className="text-sm divide-y divide-gray-100">
                {audienceProfile &&
                  audienceProfile.map((audienceProfile) => {
                    return (
                      <tr key={audienceProfile.id}>
                        <td className="p-2">{audienceProfile.profileName}</td>
                        <td className="p-2">{audienceProfile.description}</td>
                        <td className="p-2">
                          <div className="dropdown relative">
                            <a
                              className="
                              dropdown-toggle
                              transition
                              duration-150
                              ease-in-out border h-8 w-8 flex items-center justify-center rounded-md"
                              href="#"
                              type="button"
                              id="ActionButton"
                              data-bs-toggle="dropdown"
                              aria-expanded="false">
                              <i className="fas fa-ellipsis-v"></i>
                            </a>
                            <ul
                              className="dropdown-menu action-dropdown"
                              aria-labelledby="ActionButton">
                              <li
                                data-bs-toggle="modal"
                                data-bs-target="#AddNewAudienceProfile"
                                onClick={() => handleEditClick(audienceProfile.id)}>
                                <span className="dropdown-item flex-items cursor-pointer">
                                  <i className="fas fa-edit w-6"></i>
                                  <span>Edit</span>
                                </span>
                              </li>
                              <li
                                onClick={() =>
                                  handleDeleteClick({
                                    id: audienceProfile.id,
                                    name: audienceProfile.profileName
                                  })
                                }>
                                <span
                                  className="dropdown-item flex-items cursor-pointer text-red-500"
                                  data-bs-toggle="modal"
                                  data-bs-target="#DeleteAudienceProfileModal">
                                  <i className="fas fa-trash w-6"></i>
                                  <span>Delete</span>
                                </span>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            {!!audienceProfilePaginationMeta &&
              !!Object.keys(audienceProfilePaginationMeta).length && (
                <Pagination
                  currentPage={audienceProfilePaginationMeta.pageNumber}
                  totalCount={audienceProfilePaginationMeta.totalCount}
                  pageSize={audienceProfilePaginationMeta.pageSize}
                  onPageChange={(page: any) => handlePageChange(page)}
                />
              )}
          </div>
        </div>
      </div>
      <AddNewAudienceProfile contentTypeAddFlag={contentTypeAddFlag} />
      <DeleteAudienceProfileModal audienceProfileId={audienceProfileId} />
    </>
  );
};

export default AudienceProfiles;
